import "#legacy/shared/sparkle_namespace.js";
import { FINDER_MAPS_API_VERSION } from "#ce/components/SpGoogleMaps/lib/maps-api-version";

if (!(typeof Sparkle !== "undefined" && Sparkle !== null ? Sparkle.GoogleMaps : undefined)) {
  Sparkle.GoogleMaps = class GoogleMaps {
    static loadEvent = "mapsLoaded";

    static load(callback) {
      if (callback != null) {
        jQuery(document).one(this.loadEvent, callback);
      }

      if (typeof google !== "undefined" && google !== null ? google.maps : undefined) {
        console.debug("Google maps is already loaded. Skipping.");
        if (!this.promise) {
          this.promise = new jQuery.Deferred().resolve().promise();
        }
        this.scriptLoadCallback();
      } else {
        if (!this.promise) {
          this.promise = jQuery.ajax({
            url: "https://maps.googleapis.com/maps/api/js",
            dataType: "script",
            data: {
              libraries: "places,geometry",
              callback: "Sparkle.GoogleMaps.scriptLoadCallback",
              key: Sparkle.apiKeys.googleMaps,
              v: FINDER_MAPS_API_VERSION,
            },
          });
        }
      }

      return this.promise;
    }

    static scriptLoadCallback() {
      return jQuery(document).trigger(this.loadEvent);
    }

    static addAutoCompleteToField(input, parentScope, autocompleteOptions, callback) {
      input = jQuery(input).get(0);
      Sparkle.GoogleMaps.load(() => {
        if (parentScope.autocomplete) {
          return false;
        }

        const bounds = new google.maps.LatLngBounds(
          new google.maps.LatLng(
            Sparkle.Config.googleMaps.geocoderBounds.sw_lat,
            Sparkle.Config.googleMaps.geocoderBounds.sw_lng,
          ),
          new google.maps.LatLng(
            Sparkle.Config.googleMaps.geocoderBounds.ne_lat,
            Sparkle.Config.googleMaps.geocoderBounds.ne_lng,
          ),
        );

        const options = {
          fields: ["place_id"], // Default to just return the place ID to prompt developers to request only what fields they need to avoid unnecessary API usage charges
          types: ["geocode"],
          componentRestrictions: {
            country: "us",
          },
          bounds,
        };
        jQuery.extend(options, autocompleteOptions);

        return (parentScope.autocomplete = GoogleMapsAutoCompleteField.init(input, options));
      });

      if (callback) {
        return google.maps.event.addListener(parentScope.autocomplete, "place_changed", () => {
          const place = parentScope.autocomplete.getPlace();
          if (!(Object.keys(place).length > 1) && !(place.name == null)) {
            return;
          } // Check if a selection was made. See https://developers.google.com/maps/documentation/javascript/reference/places-widget#Autocomplete.place_changed
          return callback(place);
        });
      }
    }

    static mapOptions(options) {
      return {
        ...this.defaultMapOptions(),
        ...options,
      };
    }

    static defaultMapOptions() {
      return {
        zoom: Sparkle.Config.googleMaps.mapCenter.zoom,
        maxZoom: 18,
        center: new google.maps.LatLng(
          Sparkle.Config.googleMaps.mapCenter.lat,
          Sparkle.Config.googleMaps.mapCenter.lng,
        ),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        gestureHandling: "cooperative",
        disableDefaultUI: true,
        zoomControl: true,
        zoomControlOptions: {
          style: google.maps.ZoomControlStyle.SMALL,
          position: google.maps.ControlPosition.RIGHT_BOTTOM,
        },
      };
    }
  };

  var GoogleMapsAutoCompleteField = {
    init(input, options) {
      options = jQuery.extend({ defaultOnEnter: false }, options);
      if (options.defaultOnEnter) {
        this.selectFirst(input);
      }
      return new google.maps.places.Autocomplete(input, options);
    },

    selectFirst(input) {
      // store the original event binding function
      const _addEventListener = input.addEventListener ? input.addEventListener : input.attachEvent;

      const addEventListenerWrapper = (type, listener) => {
        if (type === "keydown") {
          const orig_listener = listener;
          listener = (event) => {
            const suggestion_selected = jQuery(".pac-item-selected").length > 0;
            if (event.which === 13 && !suggestion_selected) {
              const simulated_downarrow = jQuery.Event("keydown", {
                keyCode: 40,
                which: 40,
              });
              orig_listener.apply(input, [simulated_downarrow]);
            }

            return orig_listener.apply(input, [event]);
          };
        }

        return _addEventListener.apply(input, [type, listener]);
      };

      input.addEventListener = addEventListenerWrapper;
      return (input.attachEvent = addEventListenerWrapper);
    },
  };

  // Add a special event to jquery that will immediately trigger the map load event if it has already been loaded when a listener is added
  if (!jQuery.event.special[Sparkle.GoogleMaps.loadEvent]) {
    jQuery.event.special[Sparkle.GoogleMaps.loadEvent] = {
      add(handleObject) {
        if (typeof google !== "undefined" && google !== null ? google.maps : undefined) {
          return handleObject.handler();
        }
      },
    };
  }
}
